export { StructuredModuleRenderer } from './StructuredModuleRenderer';
